import axios from 'axios';

const state = {
    companies: [],
    currentCompany: null,
    loading: false,
    error: null
};

const getters = {
    allCompanies: state => state.companies,
    currentCompany: state => state.currentCompany,
    isLoading: state => state.loading,
    hasError: state => state.error !== null
};

const actions = {
    async fetchCompanies({ commit }) {
        commit('SET_LOADING', true);
        try {
            const response = await axios.get('/company');
            commit('SET_COMPANIES', response.data.companies || []);
            return response;
        } catch (error) {
            commit('SET_ERROR', error.message);
            throw error;
        } finally {
            commit('SET_LOADING', false);
        }
    },

    async createCompany({ commit }, companyData) {
        commit('SET_LOADING', true);
        try {
            const response = await axios.post('/company', companyData);
            commit('ADD_COMPANY', response.data);
            return response;
        } catch (error) {
            commit('SET_ERROR', error.message);
            throw error;
        } finally {
            commit('SET_LOADING', false);
        }
    },

    async deleteCompany({ commit }, companyId) {
        commit('SET_LOADING', true);
        try {
            await axios.delete(`/company/${companyId}`);
            commit('REMOVE_COMPANY', companyId);
        } catch (error) {
            commit('SET_ERROR', error.message);
            throw error;
        } finally {
            commit('SET_LOADING', false);
        }
    },

    async updateCompany({ commit }, { companyId, companyData }) {
        commit('SET_LOADING', true);
        try {
            const response = await axios.put(`/company/${companyId}`, companyData);
            const updatedCompany = response.data?.company || response.data;
            commit('UPDATE_COMPANY', updatedCompany);
            // Keep root Dashboard profile store in sync with company module
            commit('SET_CURRENT_COMPANY', updatedCompany, { root: true });
            return response;
        } catch (error) {
            commit('SET_ERROR', error.message);
            throw error;
        } finally {
            commit('SET_LOADING', false);
        }
    },

    async setCurrentCompany({ commit }, company) {
        commit('SET_CURRENT_COMPANY', company);
        commit('SET_CURRENT_COMPANY', company, { root: true });
        return company;
    }
};

const mutations = {
    SET_COMPANIES(state, companies) {
        state.companies = companies;
        state.error = null;
    },
    ADD_COMPANY(state, company) {
        state.companies.push(company);
        state.error = null;
    },
    REMOVE_COMPANY(state, companyId) {
        state.companies = state.companies.filter(company => company.id !== companyId);
        state.error = null;
    },
    UPDATE_COMPANY(state, updatedCompany) {
        if (!updatedCompany) {
            return;
        }
        const updatedId = String(updatedCompany.id);
        const index = state.companies.findIndex(company => String(company.id) === updatedId);
        if (index !== -1) {
            state.companies[index] = { ...state.companies[index], ...updatedCompany };
        }
        // Also update currentCompany if it's the one being updated
        if (state.currentCompany && String(state.currentCompany.id) === updatedId) {
            state.currentCompany = { ...state.currentCompany, ...updatedCompany };
        }
        state.error = null;
    },
    SET_LOADING(state, loading) {
        state.loading = loading;
    },
    SET_ERROR(state, error) {
        state.error = error;
    },
    SET_CURRENT_COMPANY(state, company) {
        state.currentCompany = company;
        state.error = null;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}; 